import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import GoalStaticTableCell from './GoalStaticTableCell';

const GoalStaticsTeamRow = ({ data, headers }) => {
  if (!data || (Array.isArray(data) && data.length === 0)) {
    return (
      <TableRow>
        <TableCell colSpan={(headers?.length || 0) + 2} align="center" sx={{ py: 3 }}>
          데이터가 없습니다.
        </TableCell>
      </TableRow>
    );
  }

  const cellStyle = {
    border: '1px solid #e0e0e0',
    fontSize: '0.875rem',
    padding: '8px',
  };

  const calculateSum = (items, headerRows) => {
    return headerRows.reduce((acc, field) => {
      const key = typeof field === 'object' ? (field.id || field.key) : field;
      const sum = items.reduce((total, item) => {
        const val = item?.[key];
        const num = (val !== undefined && val !== null && val !== '') ? Number(val) : 0;
        return total + (isNaN(num) ? 0 : num);
      }, 0);
      acc[key] = sum;
      return acc;
    }, {});
  };

  const hqCalculatedTotals = data.map((hq, index) => {
    if (hq.id === 'total' || index === data.length - 1) return null;
    const teamSubTotalRows = hq.children?.filter(dp => 
      dp.id === 'total' || dp.name === '소계'
    ) || [];
    return calculateSum(teamSubTotalRows, headers);
  });

  const grandTotalValues = calculateSum(hqCalculatedTotals.filter(Boolean), headers);

  return data.map((hq, index) => {
    const isGrandTotalHq = hq.id === 'total' || index === data.length - 1;
    const currentTotalValues = isGrandTotalHq ? grandTotalValues : hqCalculatedTotals[index];
    const enrichedHq = { ...hq, ...currentTotalValues };

    // [수정 포인트] 화면에 그릴 팀 행에서 '소계' 데이터 제외
    const displayTeams = hq?.children?.filter(dp => 
      dp.id !== 'total' && dp.name !== '소계'
    ) || [];

    const teamRows = displayTeams.map((dp, dpIndex) => {
      return (
        <TableRow key={`${hq.id}-${dp.id}`} sx={{ backgroundColor: 'inherit' }}>
          {/* 본부명: 필터링된 displayTeams의 길이에 맞춰 rowSpan 적용 */}
          {dpIndex === 0 && hq.id !== 'total' && (
            <TableCell 
              align="center" 
              rowSpan={displayTeams.length} 
              sx={{ ...cellStyle, width: '130px', fontWeight: 'bold', backgroundColor: '#f5f5f5' }}
            >
              {hq.name}
            </TableCell>
          )}
          <TableCell
            align="center"
            sx={{ 
              ...cellStyle, 
              width: '110px',
              fontWeight: 'normal',
            }}
          >
            {dp.name}
          </TableCell>
          <GoalStaticTableCell data={dp} headerRows={headers} />
        </TableRow>
      );
    });

    const hqTotalRow = (
      <TableRow key={`hq-total-${hq.id}`} sx={{ backgroundColor: isGrandTotalHq ? '#edf2f7' : '#edf2f7' }}>
        <TableCell 
          align="center" 
          colSpan={2} 
          sx={{ ...cellStyle, fontWeight: 'bold' }}
        >
          {hq.id === 'total' ? hq.name : `${hq.name} 소계`}
        </TableCell>
        <GoalStaticTableCell data={enrichedHq} headerRows={headers} />
      </TableRow>
    );

    if (hq.id === 'total') return [hqTotalRow];

    return [...teamRows, hqTotalRow];
  });
};

export default GoalStaticsTeamRow;
